import React, { useCallback, useContext } from 'react';
import { GroupWrapper } from 'src/components/profileComponents/Marketplace/components/GroupWrapper';
import { translations } from 'src/constants/translations';
import {
  UnitsDataContext,
} from 'src/components/profileComponents/Marketplace/components/UnitsTiles/context/UnitsDataProvider';
import { UnitsTile } from 'src/components/profileComponents/Marketplace/components/UnitsTiles/components/UnitTile';
import {
  GroupWrapperFiltersAction,
} from 'src/components/profileComponents/Marketplace/components/GroupWrapperActions/GroupWrapperFiltersAction';
import {
  GroupWrapperCollapseState,
} from 'src/components/profileComponents/Marketplace/components/GroupWrapperActions/GroupWrapperFiltersAction/types';
import AddIcon from '@mui/icons-material/Add';
import { MarketplaceButton } from 'src/components/profileComponents/Marketplace/components/Common/MarketplaceButton';
import { useStyles as mainUseStyles } from 'src/components/profileComponents/Marketplace/components/Common/styles';
import { RandomInteger } from 'src/helpers/randomInteger';
import { ReactSortable, Sortable, Store } from 'react-sortablejs';
import { useStyles } from '../Common/styles';

export const UnitsOrder: React.FC = () => {
  const styles = useStyles();
  const mainStyles = mainUseStyles();
  const context = useContext(UnitsDataContext);
  const [collapseState, setCollapseState] = React.useState<GroupWrapperCollapseState>(GroupWrapperCollapseState.OPEN);
  const [rocketState, setRocketState] = React.useState<boolean>(!!context?.state.unitsOrder.isActive);

  const add = () => {
    if (context) {
      context.updateState((current) => ({
        ...current,
        unitsOrder: {
          ...current.unitsOrder,
          elements: [...current.unitsOrder.elements, {
            '@id': RandomInteger().toString(),
            '@type': 'SortOrderElement',
            isDefault: false,
            property: null,
            sortOrderDirection: null,
            valueName: null,
          }],
        },
      }));
    }
  };

  const moveToTrash = (index: number) => {
    if (context) {
      context.updateState((current) => ({
        ...current,
        unitsOrder: {
          ...current.unitsOrder,
          elements: current.unitsOrder.elements.filter((_, itemIndex) => itemIndex !== index),
        },
      }));
    }
  };

  const rocketChange = (state: boolean) => {
    if (context?.state.unitsOrder) {
      context.updateState((current) => ({
        ...current,
        unitsOrder: { ...current.unitsOrder, isActive: state },
      }));
      setRocketState(state);
    }
  };

  const resetIsDefaultProperties = useCallback((index: number) => {
    if (context) {
      const sorted = context.state.unitsOrder.elements.map((item) => ({
        ...item,
        isDefault: false,
      }));
      sorted[index].isDefault = true;
      context.updateState((current) => ({
        ...current,
        unitsOrder: { ...current.unitsOrder, elements: sorted },
      }));
    }
  }, [context]);

  return (
    <>
      <GroupWrapper
        name={translations.unitsSortOrder}
        customStyles={!rocketState ? mainStyles.customGroupWrapperStyles : undefined}
        actions={(
          <GroupWrapperFiltersAction
            collapseState={collapseState}
            rocketState={rocketState}
            onRocket={rocketChange}
            onCollapse={(state) => {
              setCollapseState(state);
            }}
          />
        )}
      >
        {collapseState === GroupWrapperCollapseState.OPEN && (
          <div className={styles.wrapper}>
            <div className={styles.text}>
              {translations.newSortText}
            </div>
            <div>
              <MarketplaceButton
                startIcon={<AddIcon />}
                label={translations.newSortValue}
                onClick={() => add()}
              />
            </div>
          </div>
        ) }
      </GroupWrapper>
      {context && (
        <ReactSortable<any>
          className={mainStyles.iteratorWrapper}
          animation={150}
          handle=".drag-handle"
          list={context.state.unitsOrder.elements.map((el) => ({ ...el, chosen: false }))}
          setList={(newList, sortable: Sortable | null, store: Store) => {
            if (store && store.dragging && store.dragging.props
              && JSON.stringify(store.dragging.props.list) !== JSON.stringify(newList)) {
              context.updateState((current) => ({
                ...current,
                unitsOrder: { ...current.unitsOrder, elements: newList },
              }));
            }
          }}
        >
          { collapseState === GroupWrapperCollapseState.OPEN && context.state.unitsOrder.elements.map((item, index) => (
            <div key={item['@id']}>
              <UnitsTile
                index={index}
                entity={item}
                onChange={(updatedItem) => context.updateState((current) => ({
                  ...current,
                  unitsOrder: {
                    ...current.unitsOrder,
                    elements: current.unitsOrder.elements.map((element) => (
                      element['@id'] === updatedItem['@id'] ? updatedItem : element
                    )),
                  },
                }))}
                resetIsDefaultProperties={resetIsDefaultProperties}
                moveToTrash={moveToTrash}
              />
            </div>
          )) }
        </ReactSortable>
      ) }
    </>
  );
};
